import axios from "axios";
import type { BillingPlans } from '@/billing';
import {
    ChargeResponse,
    CryptoConfigResponse,
    DiscountCode,
    DiscountResponse,
    OrderResponse,
    PaymentDetailsResponse,
    PaymentsResponse,
    Plan,
    TrustedReseller
} from "@/api/types";

export const createPayment = (
    referral: string,
    type?: string,
    currency?: string,
    invoiceId?: number,
    sandboxCase?: string,
    discount?: string
) => {
    const body: Record<string, string | number> = {
        referral: referral || '',
        pay_currency: currency || '',
    };
    if (type) body.type = type;
    if (invoiceId != null) body.invoice_id = invoiceId;
    if (sandboxCase) body.case = sandboxCase;
    if (discount) body.discount = discount;
    return axios.post<ChargeResponse>('/payment/create/charge', body);
};

export const getCryptoConfig = () => axios.get<CryptoConfigResponse>('/payment/crypto/config');
export const getCurrencies = () => axios.get<string[]>('/payment/currencies');
export const getPaymentStatus = (paymentId: string) => axios.get(`/payment/status/${paymentId}`);

// Keep existing functions
export const createSubscription = (referral: string, plan?: string) => axios.post<OrderResponse>('/payment/create/subscription', { referral, plan});
export const updateOrder = (orderId?: string) => axios.post<{ gift?: { token: string; key?: string; plan: string; type: string } }>('/payment/update', { order_id: orderId })
export const getDiscount = (code: string) => axios.get<DiscountResponse>(`/payment/discount/${ code }`)
export const getDiscountAdvanced = (code: string) => axios.get<DiscountResponse>(`/payment/discount/advanced/${ code }`)
export const getPaymentDetails = () => axios.get<PaymentDetailsResponse>('/payment/details')
export const getBillingStatus = () => axios.get<BillingPlans>('/payment/billing-status');
export const createRenewalOrder = (product: string) => axios.post<OrderResponse>('/payment/renewal', { product });
export const getTrustedResellers = () => axios.get<TrustedReseller[]>('/payment/trusted-resellers')
export const createOrder = (plan: Plan, months: number, discount: string, referral: string) =>
    axios.post<OrderResponse>('/payment/create/order', { plan, months, discount, referral });
export const createResellerOrder = (plan: string, invoiceId: number) =>
    axios.post<OrderResponse>('/payment/create/order', { plan, invoice_id: invoiceId, months: 1, discount: '', referral: '' });
export const getPayments = (query: string, limit: number, page: number) =>
    axios.get<PaymentsResponse>('/payment/list', { params: { query, limit, page } });

// Legacy function for backward compatibility
export const createCharge = createPayment;
